import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  SET_MESSAGE,
  UPDATE_USER_PROFILE,
  UPDATE_USER_PROFILE_SUCCESS,
  UPDATE_USER_PROFILE_FAIL,
} from './types';

import AuthService from '../services/auth.service';

export const register =
  (username, fname, lname, email, password) => (dispatch) => {
    return AuthService.register(username, fname, lname, email, password).then(
      (response) => {
        if (response.data && response.data.accessToken) {
          dispatch({
            type: LOGIN_SUCCESS,
            payload: { user: response.data },
          });
        } else {
          dispatch({
            type: REGISTER_SUCCESS,
          });
        }

        dispatch({
          type: SET_MESSAGE,
          payload: response.data.message,
        });

        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        dispatch({
          type: REGISTER_FAIL,
        });

        dispatch({
          type: SET_MESSAGE,
          payload: message,
        });

        return Promise.reject();
      },
    );
  };

export const login = (username, password) => (dispatch) => {
  return AuthService.login(username, password).then(
    (data) => {
      console.log('Login response data:', data);
      console.log('User data being dispatched:', data.data);

      dispatch({
        type: LOGIN_SUCCESS,
        payload: { user: data.data },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: LOGIN_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    },
  );
};

export const logout = () => (dispatch) => {
  AuthService.logout();

  dispatch({
    type: LOGOUT,
  });
};

export const registerAgency = (agencyData) => (dispatch) => {
  return AuthService.registerAgency(agencyData).then(
    (response) => {
      if (response.data && response.data.accessToken) {
        dispatch({
          type: LOGIN_SUCCESS,
          payload: { user: response.data },
        });
      } else {
        dispatch({
          type: REGISTER_SUCCESS,
        });
      }

      dispatch({
        type: SET_MESSAGE,
        payload: response.data.message,
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: REGISTER_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    },
  );
};

export const updateUserProfile = (userId, profileData) => (dispatch) => {
  dispatch({
    type: UPDATE_USER_PROFILE,
  });

  return AuthService.updateUserProfile(userId, profileData)
    .then((response) => {
      dispatch({
        type: UPDATE_USER_PROFILE_SUCCESS,
        payload: { user: response },
      });

      dispatch({
        type: SET_MESSAGE,
        payload: 'Profile updated successfully!',
      });

      return Promise.resolve(response);
    })
    .catch((error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: UPDATE_USER_PROFILE_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject(error);
    });
};
